export enum ActionsReport {
	REQUEST_REPORT_DASHBOARD = 'REQUEST_REPORT_DASHBOARD',
	REQUEST_ANNOUNCED = 'REQUEST_ANNOUNCED',
	REQUEST_SHIPMENT = 'REQUEST_SHIPMENT',
	SET_SUMMARY = 'SET_SUMMARY',
	SET_PRODUCERS = 'SET_PRODUCERS',
	SET_PRODUCERS_COMPLETE = 'SET_PRODUCERS_COMPLETE',
	FETCH_SUMMARY = 'FETCH_SUMMARY',
	FETCH_ANNOUNCED_LOAD = 'FETCH_ANNOUNCED_LOAD',
	FETCH_SHIPMENT = 'FETCH_SHIPMENT',
	SET_STAGES = 'SET_STAGES'
}
